import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";
// import  api from  '../views/components/homePage/js/api.js'
Vue.use(Vuex);
const getters = {

}
const state = {
  userintfo: {},
  user: null,
  menus: [],//左侧总路由数据
  backBut: 1,
}
const mutations = {
  SET_USER (state, user) {
    state.user = user
  },
  editUserInfo (state, data) {
    state.userintfo = data
  },
  editMenus: (state, data) => {
    state.menus = data
  },
  editBackBut: (state, data) => {
    state.backBut = data
  },
}

const actions = {

}
// 创建 store 实例
export default new Vuex.Store({
  getters,
  state,
  mutations,
  actions,
  plugins: [createPersistedState()],
})